<!--
 * @Description: 矿粉模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-30 14:19:38
-->
<template>
    <div id="template3" class="template_table_parent">
        <table class="template_table" border="1" cellpadding="0" cellspacing="0" @click="example">
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>检测编号：</td>
                <td class="bg5"></td>
            </tr>
            <tr>
                <td>委托单位</td>
                <td class="bg5" colspan="2"></td>
                <td>品 种</td>
                <td class="bg5"></td>
                <td>出厂编号</td>
                <td class="bg5"></td>
                <td>取样日期</td>
                <td class="bg3"></td>
            </tr>
            <tr>
                <td>检测单位</td>
                <td class="bg5" colspan="2"></td>
                <td>等 级</td>
                <td class="bg5"></td>
                <td>车 牌 号</td>
                <td class="bg5"></td>
                <td>试验日期</td>
                <td class="bg3"></td>
            </tr>
            <tr>
                <td>生产厂家</td>
                <td class="bg5" colspan="2"></td>
                <td>品 牌</td>
                <td class="bg5"></td>
                <td>环境温度</td>
                <td class="bg3"></td>
                <td>代表批量</td>
                <td class="bg5"></td>
            </tr>
            <tr>
                <td>送货单位</td>
                <td class="bg5" colspan="2"></td>
                <td>样品来源</td>
                <td class="bg5"></td>
                <td>环境湿度</td>
                <td class="bg3"></td>
                <td>检测依据</td>
                <td class="bg4"></td>
            </tr>
            <tr>
                <td>进场验收项目</td>
                <td>材质证明</td>
                <td class="bg5 red" colspan="3" attrName="kjczzm" setType="select">{{tableData.kjczzm && tableData.kjczzm.hgbz && tableData.kjczzm.hgbz.label || '待配置'}}</td>
                <td>颜色对比</td>
                <td class="bg5 red" colspan="3" attrName="kjysdb" setType="select">{{tableData.kjysdb && tableData.kjysdb.hgbz && tableData.kjysdb.hgbz.label || '待配置'}}</td>
            </tr>
            <tr>
                <td>胶砂加水时间</td>
                <td class="bg3" colspan="8"></td>
            </tr>
            <tr>
                <td>试验期龄</td>
                <td colspan="4">3天</td>
                <td colspan="4">28天</td>
            </tr>
            <tr>
                <td>强度项目</td>
                <td colspan="2">强度</td>
                <td colspan="2">强度平均值</td>
                <td colspan="2">强度</td>
                <td colspan="2">强度平均值</td>
            </tr>
            <tr>
                <td rowspan="6">抗压强度（Mpa）</td>
                <td class="bg3" colspan="2"></td>
                <td class="" rowspan="6" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
                <td class="" rowspan="6" colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
            </tr>
            <tr>
                <td class="bg3" colspan="2"></td>
                <td class="bg3" colspan="2"></td>
            </tr>
            <tr>
                <td>基准水泥</td>
                <td>7天强度（Mpa）</td>
                <td class="bg5"></td>
                <td colspan="2">28天强度（Mpa）</td>
                <td class="bg5"></td>
                <td>基准流动度（mm）</td>
                <td class="bg5" colspan="2"></td>
            </tr>
            <tr>
                <td rowspan="4">检测结果</td>
                <td>7天活性指数（%）</td>
                <td class="bg1" attrName="hxzs7" setType="input">{{tableData.hxzs7 && tableData.hxzs7.hgbz || '待配置'}}</td>
                <td colspan="2">28天活性指数（%）</td>
                <td class="bg1" attrName="hxzs28" setType="input">{{tableData.hxzs28 && tableData.hxzs28.hgbz || '待配置'}}</td>
                <td>试样流动度（mm）</td>
                <td class="bg3" colspan="2"></td>
            </tr>
            <tr>
                <td>密度（g/cm³）</td>
                <td class="bg2" attrName="md" setType="input">{{tableData.md && tableData.md.hgbz || '待配置'}}</td>
                <td colspan="2">比表面积（m²/kg）</td>
                <td class="bg1" attrName="bbmj" setType="input">{{tableData.bbmj && tableData.bbmj.hgbz || '待配置'}}</td>
                <td>流动度比（%）</td>
                <td class="bg1" colspan="2" attrName="lddb" setType="input">{{tableData.lddb && tableData.lddb.hgbz || '待配置'}}</td>
            </tr>
            <tr>
                <td>三氧化硫含量（%）</td>
                <!-- <td class="bg2" attrName="syhlhl" setType="input">{{tableData.syhlhl && tableData.syhlhl.hgbz}}</td> -->
                <td class="bg1"></td>
                <td colspan="2">烧矢量（%）</td>
                <!-- <td class="bg2" attrName="ssl" setType="input">{{tableData.ssl && tableData.ssl.hgbz}}</td> -->
                <td class="bg1"></td>
                <td>样品颜色对比</td>
                <td class="bg5" colspan="2"></td>
            </tr>
            <tr>
                <td>氯离子含量（%）</td>
                <td class="bg2"></td>
                <td colspan="2">含水量（%）</td>
                <td class="bg2" attrName="hsl" setType="input">{{tableData.hsl && tableData.hsl.hgbz || '待配置'}}</td>
                <td>是否含石粉</td>
                <td class="bg5" colspan="2"></td>
            </tr>
            <tr>
                <td rowspan="2">备 注</td>
                <td rowspan="2" colspan="8"></td>
            </tr>
            <tr></tr>
            <tr>
                <td></td>
                <td>审核：</td>
                <td class="bg5" colspan="2"></td>
                <td></td>
                <td>试验：</td>
                <td class="bg5" colspan="2"></td>
                <td></td>
            </tr>
        </table>

        <SetStandardDialog :visible.sync="setStandardVisible" :config="setStandardConfig" @updated="setData"/>
    </div>
</template>
<script>
import SetStandardDialog from './SetStandardDialog'

const ARR = [
    { key: 'kjczzm', title: '材质证明', category: 7, type: 1, code: 'cell_17', verify: '请配置材质证明', options: [{value: 0, label: '齐全且一致'}, {value: 1, label: '不齐全或不一致'}]},
    { key: 'kjysdb', title: '颜色对比', category: 7, type: 1, code: 'cell_18', verify: '请配置颜色对比', options: [{value: 0, label: '相邻批次一致'}, {value: 1, label: '相邻批次不一致'}]},
    { key: 'hxzs7', title: '7天活性指数', category: 1, type: 2, code: 'cell_37', verify: '请配置7天活性指数'},
    { key: 'hxzs28', title: '28天活性指数', category: 1, type: 2, code: 'cell_38', verify: '请配置28天活性指数'},
    { key: 'md', title: '密度', category: 2, type: 2, code: 'cell_40_p04', verify: '请配置密度'},
    { key: 'bbmj', title: '比表面积', category: 1, type: 2, code: 'cell_41', verify: '请配置比表面积'},
    { key: 'lddb', title: '流动度比', category: 1, type: 2, code: 'cell_42', verify: '请配置流动度比'},
    // { key: 'syhlhl', title: '三氧化硫含量', category: 2, type: 2, code: 'cell_43_p04', verify: '请配置三氧化硫含量'},
    // { key: 'ssl', title: '烧矢量', category: 2, type: 2, code: 'cell_44_p04', verify: '请配置烧矢量'},
    { key: 'hsl', title: '含水量', category: 2, type: 2, code: 'cell_47_p03', verify: '请配置含水量'},
]

export default {
    components: {
        SetStandardDialog, // 设置标准
    },
    props: {
        templateData: {
            type: Object,
            default: () => {},
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            setStandardConfig: {},
            setStandardVisible: false,
            tableData: {},
        }
    },
    created() {
        const obj = {};
        for(let i = 0; i < ARR.length; i++) {
            obj[ARR[i].key] = {}
        }
        this.tableData = obj
        if(this.templateData) {
            this.tableData = this.templateData
        }
    },
    watch: {
        templateData: {
            deep: true,
            handler: function() {
                if(this.templateData) {
                    this.tableData = this.templateData
                } else {
                    const obj = {};
                    for(let i = 0; i < ARR.length; i++) {
                        obj[ARR[i].key] = {}
                    }
                    this.tableData = obj
                }
            },
        },
    },
    methods: {
        // 格式化数据
        fData(data) {
            if(data && data['hgbz']) {
                let type = null;
                if(Array.isArray(data['hgbz'])) type = 'input'
                if(!Array.isArray(data['hgbz'])) type = 'select'
                if(typeof data['hgbz'] === 'string') type = 'popup'
                if(type === 'input') {
                    const arr = ['合格标准', '相邻波动', '异常标准1', '异常标准2'],
                          keys = ['hgbz', 'xlbd', 'ycbz', 'ycbz2'];
                    let res = [], index
                    for (let key in data) {
                        index = keys.indexOf(key)
                        res.push({
                            code: index + 1,
                            iteam: arr[index],
                            min: data[key][0],
                            max: data[key][1],
                            format: index === 0?1:2
                        })
                    }
                    return JSON.stringify(res)
                } else if(type === 'select') {
                    return JSON.stringify({id: data.hgbz.value, value: data.hgbz.label})
                } else if(type === 'popup'){
                    return data.hgbz
                } else {
                    return ''
                }
            } else {
                return ''
            }
            
        },
        example(e) {
            if (this.readOnly) return
            // 事件委托，根据属性判断是否可以点击
            const target = e.target
            const key = target.getAttribute('attrName')
            const type = target.getAttribute('setType')
            if (key && type) {
                this.setStandard(key, type)
            }
        },
        setStandard(key, type) {
            // 设置标准
            // key 要设置的属性名
            // type 类型 input输入框 select下拉框
            if (type === 'input' || type === 'select') {
                this.setStandardConfig = {
                    key,
                    type,
                    data: this.tableData[key],
                }
                if(type === 'select') {
                    this.setStandardConfig.options = ARR.filter(item=>item.key === key)[0].options
                }
                this.setStandardVisible = true
            }
        },
        setData(data) {
            // 自定义事件的回调，设置表格属性
            if (!data.type) return
            this.tableData[data.key] = data.data;

        },
        getData() {
            for(let i = 0; i < ARR.length; i++) {
                if(this.tableData[ARR[i].key] && !this.tableData[ARR[i].key].hgbz) {
                    this.$message.info('请配置' + ARR[i].title);
                    return false;
                }
            }
            const data = {};
            for (let i = 0; i < ARR.length; i++) {
                data[ARR[i].code] = {
                    title: ARR[i].title,
                    category: ARR[i].category,
                    type: ARR[i].type,
                    condition: this.fData(this.tableData[ARR[i].key]),
                    options: ARR[i].options ? JSON.stringify(ARR[i].options.map(item=>({id: item.value, value: item.label}))) : '',
                    resultValue: ''
                }
            }
            // 暴露自身表格数据的方法，父组件通过$refs调用
            return { data, tableData: this.tableData }
        },
    },
}
</script>
<style lang="scss" scoped>
#template1 {
    width: 1200px;
}
$td_width: 100px;
$td_height: 36px;
.params_template {
    width: 100%;
    margin-top: 20px;
    .top {
        display: flex;
        margin-left: 20px;
        .params_type {
            flex: 1;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .item {
                width: 33%;
                margin-bottom: 16px;
                display: flex;
                .item_color {
                    width: 28px;
                    height: 22px;
                    margin-right: 10px;
                }
                .item_text {
                    font-weight: 400;
                }
            }
        }
        .btn {
            width: 350px;
        }
    }
    .template_content {
        width: 100%;
        height: 430px;
        overflow: auto;
    }
    .text {
        width: 100%;
        height: 500px;
        color: #ccc;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .template_table_parent {
        margin: 0 30px 20px 20px;
        table {
            border-collapse: collapse;
            border: 0 !important;
        }
        td {
            position: relative;
        }
        table,th,td{
            border: 1px solid black;
        }
        .el-date-table {
            table,th,td{
                border: 0;
            }
        }
        .bg1 { // 必检
            background: #ffff00;
            color: red;
            cursor: pointer;
        }
        .bg2 { // 选检
            background: #ffffcd;
            color: red;
            cursor: pointer;
        }
        .bg3 { // 必填
            background: #00b14b;
        }
        .bg4 { // 默认
            background: #8062a4;
        }
        .bg5 { // 系统带入
            background: #fdd5b2;
        }
        .bg6 { // 选填
            background: #90d246;
        }
        .text_color { // 业务数据及系统带入值默认颜色
            color: #777;
        }
        .red { // 配置项颜色
            color: red;
            cursor: pointer;
        }
        .template_table {
            .el-select__caret { // 下拉框的下拉箭头
                display: none;
            }
            .el-textarea__inner { // 文本域设置
                width: 100%;
                height: 100%;
                line-height: 36px;
                border: 0;
                outline: none;
                resize: none;
            }
            .el-input {
                width: 100%;
                text-align: center;
            }
            .el-input__inner {
                width: 100%;
                border: 0;
                border-radius: 0;
                background: transparent;
                color: #000;
                text-align: center;
            }
            .el-input__suffix {
                color: #000
            }
            input::-webkit-input-placeholder{
                color: #000;
            }
            .select_date {
                .el-input__inner {
                    width: 100%;
                    border: 0;
                    border-radius: 0;
                    background: transparent;
                    color: #000;
                    padding: 0 10px;
                    text-align: center;
                }
                .el-input__prefix {
                    display: none;
                }
            }
            tr:first-child, tr:last-child{
                td {
                    border: 0;
                }
            }
            td {
                width: $td_width;
                height: $td_height;
                text-align: center;
            }
        }
    }
    
}
</style>